import { render, staticRenderFns } from "./createDataSource.vue?vue&type=template&id=6f0d1c28"
import script from "./createDataSource.vue?vue&type=script&lang=js"
export * from "./createDataSource.vue?vue&type=script&lang=js"
import style0 from "./createDataSource.vue?vue&type=style&index=0&id=6f0d1c28&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports